import { MakerListAttrs } from "@locent/types";

import { BaseComponent } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";
import { MakerItem } from "../base/baseType";

/** 游戏厂商列表组件类 */
export class MakerListComponent extends BaseComponent<
  MakerListAttrs & {
    [key: string]: string | number | boolean | object | null | undefined;
  }
> {
  constructor(
    data: Partial<
      BaseComponent<
        MakerListAttrs & {
          [key: string]: string | number | boolean | object | null | undefined;
        }
      >
    > = {},
  ) {
    super(data);
    this.type = CompType.maker_list;
  }

  /** 获取游戏厂商列表 */
  public getMakers(): MakerItem[] {
    // 依照 power 权重排序
    // console.log("this.makers", this.makers);
    // const sortMakerList =
    //   this.makers?.slice()?.sort((a, b) => b.power - a.power) || this.makers;

    return this.makers || [];
  }

  /** 获取标题文本 */
  public getTitle(): string {
    return this.title;
  }

  /** 获取行数 */
  public getLine(): number {
    return this.lang_attrs?.line;
  }
}

// 使用示例
// const makerListData: Partial<BaseComponent<MakerListAttrs>> = {
//   id: "6718c1f156888a9d31587def",
//   type: CompType.maker_list,
//   variant: "",
//   title: "",
//   status: 1,
//   sort: 0,
//   login_type: LoginType.Login,
//   recharge_type: RechargeType.Recharge,
//   fixed_top: 0,
//   key: "maker_list_1729675761",
//   show_rtp: false,
//   height: "",
//   attrs: {
//     title_text: {
//       "12": "游戏厂商XY",
//       "1": "游戏厂商EN",
//       "4": "游戏厂商ZH",
//       "11": "游戏厂商PT",
//     },
//     line: 1,
//   },
//   makers: [
//     {
//       tag: "3Oaks",
//       maker_ids: [10045],
//       logo: "3Oaks",
//       power: 1,
//       name: "3Oaks",
//       gclass_list: [2],
//       game_count: 10,
//     },
//   ],
// };
